import { PlayerState, DiceValue, TOKENS_PER_PLAYER } from './types';
import { RuleEngine } from './RuleEngine';

export class TurnManager {
  private _currentPlayerIndex: number = 0;
  private _ruleEngine: RuleEngine;
  private _consecutivePasses: number = 0;

  constructor(ruleEngine: RuleEngine) {
    this._ruleEngine = ruleEngine;
  }

  get currentPlayerIndex(): number { return this._currentPlayerIndex; }
  get consecutivePasses(): number { return this._consecutivePasses; }

  setCurrentPlayerIndex(index: number): void {
    this._currentPlayerIndex = index;
  }

  getNextPlayer(
    currentPlayerIndex: number,
    _diceValue: DiceValue,
    _player: PlayerState,
    _hadCapture: boolean,
    allPlayers: PlayerState[],
  ): number {
    return this.advanceToNextActive(currentPlayerIndex, allPlayers);
  }

  advanceToNextActive(fromIndex: number, players: PlayerState[]): number {
    const count = players.length;
    for (let i = 1; i <= count; i++) {
      const next = (fromIndex + i) % count;
      if (players[next].finishedCount < TOKENS_PER_PLAYER) {
        return next;
      }
    }
    return fromIndex;
  }

  hasValidMoves(playerIndex: number, diceValue: DiceValue, players: PlayerState[]): boolean {
    const moves = this._ruleEngine.getValidMoves(playerIndex, diceValue, players);
    return moves.length > 0;
  }

  skipTurn(
    playerIndex: number,
    diceValue: DiceValue,
    player: PlayerState,
    players: PlayerState[],
  ): number {
    this._consecutivePasses++;
    if (diceValue === 6) {
      player.consecutiveSixes++;
    } else {
      player.consecutiveSixes = 0;
    }
    return this.advanceToNextActive(playerIndex, players);
  }

  reset(): void {
    this._currentPlayerIndex = 0;
    this._consecutivePasses = 0;
  }
}
